import isEqual from 'lodash/isEqual';
import uniqBy from 'lodash/uniqBy';

import {
  DEFAULT_GROUP,
  EMPTY_STATE_SEARCH,
} from '~/components/SearchBuilder/utils/constants';

const NOOP_SEARCH = {
  and: [DEFAULT_GROUP],
  version: 2,
};

export function normalizeSearch(search) {
  if (isEqual(search, NOOP_SEARCH)) {
    return null;
  }

  if (isEqual(search, EMPTY_STATE_SEARCH)) {
    return null;
  }

  return search;
}

export const EMPTY_AUDIENCE_PERSON_ATTRIBUTE_SEARCH = {
  and: [
    {
      and: [
        {
          match_any: {
            value: [],
            attribute: 'person->employment->seniority',
          },
        },
        {
          parentAttribute: 'person->employment->role',
          comparator: 'match_any',
        },
      ],
    },
  ],
  version: 2,
};

export const EMPTY_AUDIENCE_PERSON_ATTRIBUTE_SEARCH_WITH_TITLE_KEYWORDS = {
  and: [
    {
      and: [
        {
          match_any: {
            value: [],
            attribute: 'person->employment->seniority',
          },
        },
        {
          parentAttribute: 'person->employment->role',
          comparator: 'match_any',
        },
        {
          contains_any: {
            value: [],
            attribute: 'person->employment->title',
          },
        },
      ],
    },
  ],
  version: 2,
};

/**
 * TODO move logic to backend
 */

const injectedPersonAttributes = [
  {
    category: 'clearbit',
    details: {
      type: 'keyword_string',
    },
    label: 'Title Keywords',
    subCategory: null,
    value: 'person->employment->title',
  },
];

/**
 * Returns the person attributes scoped to the account.
 *
 * Attributes come from the server as well as are injected on the client.
 * They are de-duped FIFO.
 */

export function filterPersonAttributes(account, attributes) {
  return uniqBy(
    injectedPersonAttributes
      .concat(attributes)
      .filter((attribute) =>
        hasAccessToPersonAttribute(account?.id, attribute.value),
      ),
    'value',
  );
}

export const CLEARBIT_PRODUCTION = '0166cbcb-7827-4698-a267-fec98676db0b';
export const CLEARBIT_X_ENGINEERING = '0ca84662-ed43-4a96-8a89-a0916a9a2994';

/**
 * TODO move logic to backend
 */

const allowlistedPersonAttributes = [
  CLEARBIT_PRODUCTION,
  CLEARBIT_X_ENGINEERING,
];

const filteredPersonAttributes = [
  'person->employment->role',
  'person->employment->seniority',
  'person->employment->title',
  'person->geo->country',
  'person->geo->state',
];

function hasAccessToPersonAttribute(accountId, value) {
  if (allowlistedPersonAttributes.includes(accountId)) {
    return true;
  }

  return filteredPersonAttributes.includes(value);
}
